var firstBy = require("thenby");

export function isArray(A:any):boolean { return Object.prototype.toString.call(A) == "[object Array]"; }
export function isFile(F:any):boolean { return Object.prototype.toString.call(F) == "[object File]"; }
export function isFunction(F:any):boolean { return Object.prototype.toString.call(F) == "[object Function]"; }
export function isNumeric(N:any):boolean { return parseFloat(N)==N; /*N.match(/^\d+$/);*/ }
export function isObject(O:any):boolean { return Object.prototype.toString.call(O) == "[object Object]"; }
export function isString(S:any):boolean { return Object.prototype.toString.call(S) == "[object String]"; }

export var Type = Function;
/**
 * Runtime representation a type that a Component or other object is instances of.
 *
 * An example of a `Type` is `MyCustomComponent` class, which in JavaScript is be represented by
 * the `MyCustomComponent` constructor function.
 */
export interface Type extends Function {}

/**
 * Runtime representation of a type that is constructable (non-abstract).
 */
export interface ConcreteType extends Type { new (...args): any; }

export function getTypeNameForDebugging(type: Type): string {
    if (type['name']) {
        return type['name'];
    }
    return typeof type;
}

export function hasConstructor(value: Object, type: Type): boolean {
    return value.constructor === type;
}

export function isMobile() : boolean {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone|Opera Mini/i.test(navigator.userAgent);
};

export function isPresent(obj: any): boolean {
    return obj !== undefined && obj !== null;
}

export function isEmptyObject(obj:Object) :boolean {
  return obj && Object.keys(obj).length==0; 
}

export function isBlank(obj: any): boolean {
    return obj === undefined || obj === null;
}

export function isBoolean(B: any): boolean {
    //return this.toString.call(B) == "[object Boolean]"; 
    return B !== undefined && (typeof B === "boolean");
}

export function isType(obj: any): boolean {
    return isFunction(obj);
}

export function isStringMap(obj: any): boolean {
    return typeof isObject(obj) && obj !== null;
}

export function isDate(D:any): boolean {
    return D !== undefined && (D instanceof Date) && !isNaN(D.valueOf());
}

export function isJsObject(O:any): boolean {
    return O !== undefined && (typeof O === "function" || typeof O === "object");
}

export function isPrimitive(P:any): boolean {
    return !isJsObject(P);
}

export function isPromise(P) {
    return P !== undefined && typeof P.subscribe !== 'function' && typeof P.then === 'function';
}

export function normalizeBlank(obj: Object): any {
    return isBlank(obj) ? null : obj;
}

export function normalizeBool(obj: boolean): boolean {
    return isBlank(obj) ? false : obj;
}

export function bitWiseOr(values: number[]): number {
    return values.reduce((a, b) => { return a | b; });
}

export function bitWiseAnd(values: number[]): number {
    return values.reduce((a, b) => { return a & b; });
}

export function dataURLtoBlob(dataURL) {
  var binary = atob(dataURL.split(',')[1]);
  var array = [];
  for(var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], {type: 'image/jpeg'});
}

export function hasTag() : string | undefined {
  return window.location.hash || undefined;
}

export function ScreenDPI() {
  let b = document.body;
  let d = document.createElement('div');
  d.style.position = 'absolute';
  d.style.left = '-10in';
  d.style.width = '1in';
  d.style.height = '1in';
  d.style.display = 'none';
  b.appendChild(d);
  let s = window.getComputedStyle(d);
  let dpi = {
    x: parseInt(s.width),
    y: parseInt(s.height)
  };
  b.removeChild(d); // IMPORTANT: remove it after got its style
  return dpi;
}

/**
 * jsonToUrl()
 * Append json-object {} to url as querystring.
 * 
 * jsonToUrl({a:"b",c:"d"},"http://any.url/upload?otherParam=value");`
 *
 * will result in:
 * http://any.url/upload?otherParam=value&a=b&c=d
 *
 * @param  Object JSON-Object
 * @param  String current querystring-part
 * @return String encoded querystring
 */
export function jsonToUrl(json, url, prefixDone) {
  let i, uristrings = [],
    prefix = "&",
    add = function(nextObj, i) {
      let nextTemp = url ? 
        (/\[\]$/.test(url)) ? // prevent double-encoding
            url : url + "[" + i + "]"
        : i;
      if ((nextTemp != "undefined") && (i != "undefined")) {
        uristrings.push(
          (typeof nextObj === "object") 
            ? this.jsonToUrl(nextObj, nextTemp, true)
            : (Object.prototype.toString.call(nextObj) === "[object Function]")
              ? encodeURIComponent(nextTemp) + "=" + encodeURIComponent(nextObj())
              : encodeURIComponent(nextTemp) + "=" + encodeURIComponent(nextObj) 
        );
      }
    }; 

  if (!prefixDone && url) {
    prefix = (/\?/.test(url)) ? (/\?$/.test(url)) ? "" : "&" : "?";
    uristrings.push(url);
    uristrings.push(this.jsonToUrl(json));
  } else if ((Object.prototype.toString.call(json) === "[object Array]") && (typeof json != "undefined") ) {
    // we wont use a for-in-loop on an array (performance)
    for (i=0; i<json.length; ++i) {
      add(json[i], i);
    }
  } else if ((typeof json != "undefined") && (json !== null) && (typeof json === "object")){
    // for anything else but a scalar, we will use for-in-loop
    for (i in json){
      add(json[i], i);
    }
  } else {
    uristrings.push(encodeURIComponent(url) + "=" + encodeURIComponent(json));
  }
  return uristrings.join(prefix).replace(/^&/, "").replace(/%20/g, "+"); 
}

//Parse component template attribute, i.e. key:value pairs to JSON object
export function parseAttr(S:string) {
    S = (S+'').replace(/(\r\n|\n|\r|\t)+/g,'').trim();
    let json:any = {};
    let kvs: Array<string>;
    let n = S.length - 1;

    kvs = S.split(';'); //not ','
    kvs.forEach((kv) => {
        let i:number;
        kv = (kv+'').trim();
        if (kv) {
            i = kv.indexOf(':');
            if (i==-1) {
                json[kv] = true; //key only
            } else {
                n = kv.length - 1;
                if (i==0 || i==n) {
                    //ignore this since it is not a valid key: or :value that is not valid pair
                } else {
                    //let k:string = kv.substring(0,i).trim();
                    //camelized the key
                    let k:string = kv.substring(0,i).trim().toLowerCase().replace(/(\-\w)/g, function(m){return m[1].toUpperCase();});
                    let v:string = kv.substring(i+1).trim();
                    if (!v || v=='' || v=='undefined' || v==undefined) {
                        //ignore this attribute
                    } else if (v.toLowerCase()=='true') {
                        json[k] = true;
                    } else if (v.toLowerCase()=='false') {
                        json[k] = false;
                    } else if (this.isNumeric(v)){
                        json[k] = parseFloat(v);
                    } else {
                        json[k] = v;
                    }
                }
            }
        }
    }, this);
    return json;
}

export function parseValue(value, dataType) {
  // parse value for saving in database
  if (value===null || value===undefined) {
    return null;
  }
  switch (dataType) {
  case "double":
  case "decimal":
  case "number":
  case "numeric":
    value = parseFloat(value);
    if (isNaN(value)) value = null;
    break;
  case "integer":
    value = parseInt(value);
    if (isNaN(value)) value = null;
    break;
  case "hidden":
    break;
  case "boolean":
    value = !!value;
    break;
  case "date":
  case "time":
    try {
      if (value) {
        if (!(value instanceof Date)) {
          value = new Date(value);
        }
        let yyyy = value.getFullYear();
        let mm = value.getMonth();
        let dd = value.getDate();
        if (yyyy>2500) {
          yyyy -= 543;
          value = new Date(yyyy,mm,dd);
        }
        if (dataType=='date') {
          mm++
          return yyyy + '-' + ('0' + mm).slice(-2) + '-' + ('0' + dd).slice(-2);
        } else {
          value = (<Date> value).toISOStringWithTimeZone();
        }
      }
    } catch (error) {
      value = null;
    }
    break;
  default:
    //trim() and escape single (') to double ('')
    value = value ? (value+'').replace(/^\s\s*/, "")
                  .replace(/\s\s*$/, "")
                  .replace(/\s+/g," ")
                  .replace(/\'/g, "''") : value;
    break;
  }
  return value;
}

export function mergeJson(target:Object, source:Object, recursive:boolean): Object {
    target = target || {};
    source = source || {};
    var self = this;
    for (var p in source) {
        if (source.hasOwnProperty(p)) {
            if (this.isObject(source[p]) && target[p] && this.isObject(target[p])) {
                target[p] = self.mergeJson(target[p],source[p],recursive);
            } else if (this.isArray(source[p])) {
                target[p] = source[p]; //to do: union of the two arrays
            } else {
                target[p] = source[p];
            }
        }
    }
    return target;
}

export function Linkify(text:string, target?:string) {
  target = target ? ('target="' + target + '"') : '';

  //URLs starting with http://, https://, or ftp://
  let urls = [
      //URLs starting with http://, https://, or ftp://
      {   pattern: /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim,
          replacer: '<a href="$1" ' + target + '>$1</a>'
      },
      //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
      {   pattern: /(^|[^\/])(www\.[\S]+(\b|$))/gim,
          replacer: '$1<a href="http://$2" ' + target + '>$2</a>'
      },
      //Change email addresses to mailto:: links.
      {   pattern: /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim,
          replacer: '<a href="mailto:$1">$1</a>'
      }
  ];
  let newText = text + '';
  urls.forEach((url) => {
      newText = newText.replace(url.pattern,url.replacer);
  }, this);

  return newText;
}

export function getConsonant(text:string) : string {
  return !text ? '' :
    text.replace(/[aeiou\'\'\"~!@#$%^&*()\-_+=`{}\[\]\|\\:;<>,\./? ็็็ึึึะาิีุูเแโีืัใไำ่้๊๋์ึ็็]/ig,'');
}

export function createDate(value) {
  let timeZoneOffset = (new Date()).getTimezoneOffset() * 60000; //min to millisecond
  if (!value) {
    return null;
  } else if (isNumeric(value)) {
    return new Date(value + timeZoneOffset);
  } else if (isString(value)) {
    //value:yyyy-mm-dd hh:mm:ss is a local date string
    let d:any = value.split(' ');
    if (d.length==2) {
      value = d.join('T');
    }
    d = new Date(value).getTime(); // + timeZoneOffset;
    return new Date(d);
  }
  return null;
}

export function beginOfBudgetYears() : {[key:string] : Date} {
  let bYears = {
    present:null, last:null
  }
  let today = new Date();
  let thisMonth = today.getMonth() + 1;
  let year = today.getFullYear();
  if (thisMonth>=10) {
    year++;
  }
  bYears.present = new Date(year, 9, 1);
  year--;
  bYears.last = new Date(year, 9, 1);
  return bYears;
}

export function DateOfNDaysBefore(days:number, thisDate:Date) : Date {
  let d = new Date(thisDate.getTime() - days * 24 * 60 * 60 * 1000);
  return d;
}

export function DateOfNMonthsBefore(nMonths:number, thisDate:Date) : Date {
  let d = SameDateOfNMonthsBefore(nMonths,thisDate);
  return new Date(d.getFullYear(),d.getMonth(),d.getDate()+1);
}

export function SameDateOfNMonthsBefore(nMonths:number, thisDate:Date) : Date {
  let yy = thisDate.getFullYear();
  let mm = thisDate.getMonth() - nMonths;
  let dd = thisDate.getDate();
  let lastDateOfNMonthBefore = new Date(yy, mm+1, 0);
  if (dd>lastDateOfNMonthBefore.getDate()) {
      return lastDateOfNMonthBefore;
  }
  return new Date(yy, mm,dd);
  //return (mm>0) ? new Date(yy, mm-1, dd) : new Date(yy-1, 11+mm, dd);
}

export function SameDateOfLastMonth(thisDate:Date) : Date {
  return SameDateOfNMonthsBefore(1, thisDate);
  /*let yy = thisDate.getFullYear();
  let mm = thisDate.getMonth();
  let dd = thisDate.getDate();
  let lastDateOfPreviousMonth = new Date(yy, mm, 0);
  if (dd>lastDateOfPreviousMonth.getDate()) {
      return lastDateOfPreviousMonth;
  }
  return (mm>0) ? new Date(yy, mm-1, dd) : new Date(yy-1, 11, dd);*/
}

export function SameDateOfNMonthsAfter(nMonths, thisDate:Date) : Date {
  let yy = thisDate.getFullYear();
  let mm = thisDate.getMonth() + nMonths;
  let dd = thisDate.getDate();
  if (mm >= 12) {
    yy++;
    mm -= 12;
  }
  let lastDateOfNMonthsAfter = new Date(yy, mm, 0);
  if (dd>lastDateOfNMonthsAfter.getDate()) {
    return lastDateOfNMonthsAfter;
  }
  return new Date(yy, mm, dd);
}

export function SameDateOfNextMonth(thisDate:Date) : Date {
  return SameDateOfNMonthsAfter(1, thisDate);
  /*let yy = thisDate.getFullYear();
  let mm = thisDate.getMonth() + 1;
  let dd = thisDate.getDate();
  if (mm >= 12) {
    yy++;
    mm -= 12;
  }
  let lastDateOfNextMonth = new Date(yy, mm, 0);
  if (dd>lastDateOfNextMonth.getDate()) {
    return lastDateOfNextMonth;
  }
  return new Date(yy, mm, dd);*/
}

export function calculateAge(dob:Date) : [number,number,number] {
  let today = new Date();
  let yd = today.getFullYear();
  let md = today.getMonth();
  let dd = today.getDate();
  let yb = dob.getFullYear();
  let mb = dob.getMonth();
  let db = dob.getDate();
  let ma=0;
  let ya=0;
  let da = dd-db;
   // This is the all-important day borrowing code.
   if(da<0) {
      md--;
      // Borrow months from the year if necesssary.
      if(md<0) {
	      yd--;
        // Determine no. of months in year
        md += 12;
      }
      da += (new Date(yd,(md+1),0)).getDate();
   }
   ma = md - mb;
   // Month borrowing code - borrows months from years.
   if(ma<0) {
      yd--;
      ma += 12;
   }
   ya = yd - yb;

   return [ya,ma,da];
}

export function sortObjectArray(array: Array<any>, args: string | Array<string>): Array<any> { 
  if (!array || array.length==0) {
    return array;
  }
  let params: Array<string>;
  let parses: Array<string>;
  let p: string | Function;
  let s;
  if (args) {
    try {
      if (isString(args)) {
        params = args.toString().split(',');
      } else {
        params = <Array<string>> args;
      }
      params.forEach((arg, i) => {
        parses = arg.split(' ');
        let pi:number = parses[0].indexOf('.');
        let p1:string, p2:string;
        if (pi > 0) {
          p1 = parses[0].substr(0,pi);
          p2 = parses[0].substr(pi+1);
          p = function(a,b) {
            let v1 = a[p1] ? a[p1][p2] : null;
            let v2 = b[p1] ? b[p1][p2] : null;
            if (isString(v1) || isString(v2)) {
              v1 = v1 ? (v1+'').toLowerCase() : null;
              v2 = v2 ? (v2+'').toLowerCase() : null;
            }
            return (v1==v2) ? 0 : (!v1 || v1>v2) ? 1 : -1;
          }
        } else {
          p = parses[0];
        }
        if (i==0) {
          if (parses.length>1 && parses[1].toLowerCase()=='desc') {
            s = firstBy(p,{ignoreCase:true, direction:-1});
          } else {
            s = firstBy(p, {ignoreCase:true});
          }
        } else {
          if (parses.length>1 && parses[1].toLowerCase()=='desc') {
            s = s.thenBy(p,{ignoreCase:true, direction:-1});
          } else {
            s = s.thenBy(p, {ignoreCase:true});
          }
        }
      }, this);
    } catch (e) {
      console.log('utils.sortObjectArray() ' + e);
    }
  }
  array.sort(s);
  return array;
}

